import React, { useState, useEffect, useCallback } from "react";
import CloseIcon from '@mui/icons-material/Close';
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const ModalWithMap = ({ isOpen, onClose, onConfirm, defaultLocation }) => {
  const [marker, setMarker] = useState(defaultLocation);
  const [address, setAddress] = useState("");
  const [predictions, setPredictions] = useState([]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCDBR7BqAww184lcgb0zc83uhLeX-JFoOk",
    libraries: ["places"], 
  });

  useEffect(() => {
    setMarker(defaultLocation);
  }, [defaultLocation]);

  const handleMapClick = useCallback((e) => {
    setMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() });
  }, []);

  // ✅ When user types, fetch predictions
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setAddress(value);

    if (!value || !window.google) {
      setPredictions([]);
      return;
    }

    const service = new window.google.maps.places.AutocompleteService();
    service.getPlacePredictions(
      { input: value, componentRestrictions: { country: "in" } }, // limit to India
      (results, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setPredictions(results);
        } else {
          setPredictions([]);
        }
      }
    );
  };

  // ✅ When user selects a place
  const handlePredictionSelect = (prediction) => {
    setAddress(prediction.description);
    setPredictions([]);

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId: prediction.place_id }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        const newMarker = { lat: location.lat(), lng: location.lng() };
        setMarker(newMarker);
      }
    });
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          padding: "20px",
          width: "80%",
          maxWidth: "600px",
          height: "500px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h3>Select your location</h3>

        {/* 🔍 Search Bar */}
        <div style={{ position: "relative", marginBottom: "10px" }}>
          <input
            type="text"
            value={address}
            onChange={handleSearchChange}
            placeholder="Search by city, places"
            style={{
              width: "97%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
          {address.length>0 && (
            <CloseIcon
            fontSize="small"
            onClick={() => {
              setAddress("");
              setPredictions([]);
            }}
            style={{
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "red"
            }}
          />

          )}
          

        
          {predictions.length > 0 && (
            <ul
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                background: "#fff",
                border: "1px solid #ccc",
                borderRadius: "4px",
                maxHeight: "150px",
                overflowY: "auto",
                zIndex: 2000,
                listStyle: "none",
                margin: 0,
                padding: 0,
              }}
            >
              {predictions.map((p) => (
                <li
                  key={p.place_id}
                  onClick={() => handlePredictionSelect(p)}
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {p.description}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* 🗺️ Map */}
        <div style={{ flex: 1 }}>
          {isLoaded ? (
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={marker}
              zoom={15}
              onClick={handleMapClick}
            >
              <Marker
                position={marker}
                draggable={true}
                onDragEnd={(e) =>
                  setMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() })
                }
              />
            </GoogleMap>
          ) : (
            <p>Loading map...</p>
          )}
        </div>

        {/* Buttons */}
        <div style={{ marginTop: "10px", textAlign: "right" }}>
          <button
            onClick={onClose}
            style={{
              marginRight: "10px",
              padding: "8px 12px",
              background: "#f44336",
              color: "white",
              border: "none",
              borderRadius: "4px",
            }}
          >
            Cancel
          </button>

          <button
            onClick={() => onConfirm(marker)}
            style={{
              padding: "8px 12px",
              background: "#4CAF50",
              color: "white",
              border: "none",
              borderRadius: "4px",
            }}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalWithMap;
